const style = theme => ({
  container: {
    width: '100%',
    marginTop: theme.spacing(3),
  },

})

export default style
